import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=3c38bc28&scoped=true&"
import script from "./Bill.vue?vue&type=script&lang=ts&"
export * from "./Bill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38bc28",
  null
  
)

export default component.exports